import { useStore, computed } from "@nuxtjs/composition-api";
import { ref } from "@nuxtjs/composition-api";
import { useFocus } from "@vueuse/core";

export default function useCompanySearch(){
    const focusableElement = ref();
    const store = useStore();
    const { focused } = useFocus({
      target: focusableElement,
    });
    const keyword = ref('');
    const hot_keywords = computed(() => {
      return store.state.company.hot_keywords
    })
    

    return {
        focusableElement,
        focused,
        keyword,
        hot_keywords
    }
}